import { Column } from "react-table";
import {
  GetComplianceInvestigationOutcomesFetchUrl,
  IComplianceInvestigationOutcome,
} from "../../api/ComplianceInvestigation/IComplianceInvestigationOutcome";
import { Grid } from "../Grid";
import { ComplianceInvestigationOutcomesGridProps } from "./ComplianceInvestigationOutcomesGridProps";

const ComplianceInvestigationOutcomesGrid = ({
  complianceInvestigationId,
  licenceProfile,
}: ComplianceInvestigationOutcomesGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetComplianceInvestigationOutcomesFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(complianceInvestigationId);

  const tableColumnsBig: Column<
    Record<string, IComplianceInvestigationOutcome>
  >[] = [
    {
      Header: "Type",
      accessor: "outcometype",
      Filter: false,
    },
    {
      Header: "Category",
      accessor: "outcomecategory",
      Filter: false,
    },
    {
      Header: "Sub Category",
      accessor: "outcomesubcategory",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Description",
      accessor: "description",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IComplianceInvestigationOutcome>
  >[] = [
    {
      Header: "Type",
      accessor: "outcometype",
      Filter: false,
    },
    {
      Header: "Description",
      accessor: "description",
      Filter: false,
      filter: "includes",
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ComplianceInvestigationOutcomesGrid };
